module.exports = __webpack_public_path__ + "img/carshove_thumb.892b1145.jpg";